module.exports = __webpack_public_path__ + "static/media/ios.ac1e6720.svg";